import type { CSSProperties } from 'react'

/** Icônes maison : SVG inline, aucune librairie externe. */
const P = {
  dash: 'M3 10.5 10 4l7 6.5M5.5 9v7h9V9',
  station:
    'M4 17V4h8v13M4 17h11M12 8h2.5a2 2 0 0 1 2 2v4.5a1.5 1.5 0 0 0 1.5 1.5M6.5 6.5h3v2.5h-3z',
  shield: 'M10 2.5 4 5v5c0 3.6 2.4 6.6 6 7.5 3.6-.9 6-3.9 6-7.5V5l-6-2.5ZM7.6 10l1.7 1.8L13 8',
  gauge: 'M10 16a6 6 0 1 1 6-6M10 10l3.5-2.5',
  ticket: 'M3 6.5h14v3a1.5 1.5 0 0 0 0 3v3H3v-3a1.5 1.5 0 0 0 0-3v-3ZM8 6.5v10',
  tank: 'M4.5 6.5h11v9a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5v-9ZM4.5 6.5 10 3l5.5 3.5M4.5 12.5h11',
  regle: 'M3 7.5h14v5H3zM6 7.5v3M9 7.5v2M12 7.5v3M15 7.5v2',
  truck:
    'M2.5 5.5h9v8h-9zM11.5 8.5h3l2.5 2.5v2.5h-5.5zM6 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
  users:
    'M7.5 9.5a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM2.5 16.5c0-2.5 2.2-4.2 5-4.2s5 1.7 5 4.2M13.5 6.2a2.2 2.2 0 1 1 0 4.4M14.5 12.6c1.8.4 3 1.8 3 3.9',
  coins:
    'M10 5.5c3.3 0 6 1.1 6 2.5S13.3 10.5 10 10.5 4 9.4 4 8s2.7-2.5 6-2.5ZM4 8v4c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5V8',
  cart: 'M3 4h2l2 8.5h8L17 7H6M8 16.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM14.5 16.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  chart: 'M3.5 16.5h13M6 14V9m4 5V5m4 9v-6',
  bell: 'M10 2.5a5 5 0 0 0-5 5v3.2L3.6 13.2a.6.6 0 0 0 .5.9h11.8a.6.6 0 0 0 .5-.9L15 10.7V7.5a5 5 0 0 0-5-5ZM8 16.2a2 2 0 0 0 4 0',
  wrench:
    'M13.2 3.4a4 4 0 0 0-4.9 5.2L3 13.9 6.1 17l5.3-5.3a4 4 0 0 0 5.2-4.9l-2.5 2.5-2.3-.5-.5-2.3 2.5-2.5Z',
  plug: 'M7 3v4M13 3v4M5 7h10v3a5 5 0 0 1-10 0V7ZM10 15v2.5',
  star: 'M10 3l2.2 4.5 5 .7-3.6 3.5.9 4.9-4.5-2.4-4.5 2.4.9-4.9L2.8 8.2l5-.7L10 3Z',
  bank: 'M10 3 3 7h14l-7-4ZM5 9v5M9 9v5M13 9v5M3 16.5h14',
  gear: 'M10 12.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM10 2.6l1 2 2.2-.5 1 1.8-1.5 1.6.6 2.1 2 .9-.3 2-2.2.3-.9 2 1.2 1.8-1.5 1.4-1.9-1.2-1.9 1.2-1.5-1.4 1.2-1.8-.9-2-2.2-.3-.3-2 2-.9.6-2.1L4.4 6l1-1.8 2.2.5 1-2Z',
  doc: 'M5 2.5h6.5L15 6v11.5H5zM11.5 2.5V6H15',
  phone:
    'M6.5 2.5h7a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 5 16V4a1.5 1.5 0 0 1 1.5-1.5ZM8.5 15h3',
  eye: 'M10 5c-4 0-6.5 5-6.5 5S6 15 10 15s6.5-5 6.5-5S14 5 10 5ZM10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  camera: 'M3 6.5h3l1.2-2h5.6L14 6.5h3v9H3zM10 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  search: 'M9 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM13.5 13.5 17 17',
  check: 'M4 10.5 8 14.5 16 6',
  warn: 'M10 3.5 18 16.5H2L10 3.5ZM10 8v4M10 14.2v.1',
  down: 'M10 4v9m0 0 4-4m-4 4-4-4M4 16.5h12',
  plus: 'M10 4v12M4 10h12',
  clock: 'M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM10 6v4.2l2.8 1.7',
  pin: 'M10 17s5.5-5 5.5-9a5.5 5.5 0 1 0-11 0c0 4 5.5 9 5.5 9ZM10 10.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z',
  back: 'M16 10H4m0 0 5-5m-5 5 5 5',
  menu: 'M3 5h14M3 10h14M3 15h14',
  close: 'M5 5l10 10M15 5L5 15',
  moon: 'M10 2.5a7.5 7.5 0 1 0 7.5 7.5A6 6 0 0 1 10 2.5Z',
  lock: 'M5.5 9h9v8h-9zM7.5 9V6.5a2.5 2.5 0 0 1 5 0V9',
  droplet: 'M10 3s5 5.4 5 8.5a5 5 0 0 1-10 0C5 8.4 10 3 10 3Z',
  chev: 'M6 8l4 4 4-4',
  temp: 'M8.5 11.6V5a1.5 1.5 0 0 1 3 0v6.6a3 3 0 1 1-3 0Z',
} as const

export type IconName = keyof typeof P

export function Icon({
  name,
  className,
  size,
  style,
}: {
  name: IconName
  className?: string
  size?: number
  style?: CSSProperties
}) {
  return (
    <svg
      viewBox="0 0 20 20"
      aria-hidden="true"
      className={`ic${className ? ` ${className}` : ''}`}
      style={size ? { width: size, height: size, ...style } : style}
    >
      <path
        d={P[name]}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/** Le logo : une pompe stylisée, dessinée à la main. */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 40" aria-hidden="true" className={className}>
      <path
        d="M7 34V9a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v25"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
      />
      <rect x="11" y="11" width="9" height="7" rx="1" fill="currentColor" />
      <path
        d="M24 15h4a3 3 0 0 1 3 3v10a2.5 2.5 0 0 0 2.5 2.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
      />
      <path d="M4 34h23" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" />
    </svg>
  )
}
